export default __webpack_public_path__ + "static/media/23.7bac538f.jpg";